import { render, staticRenderFns } from "./personLabel.vue?vue&type=template&id=4b0d6709&scoped=true&"
import script from "./personLabel.vue?vue&type=script&lang=js&"
export * from "./personLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d6709",
  null
  
)

export default component.exports